/**
 * Teals Design System - Transition Tokens
 *
 * Animation and transition timing values.
 */
export const durations = {
    instant: '0ms',
    fast: '100ms',
    normal: '200ms',
    slow: '300ms',
    slower: '400ms',
    slowest: '500ms',
};
export const easings = {
    linear: 'linear',
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    easeOut: 'cubic-bezier(0, 0, 0.2, 1)',
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Custom easings
    bounce: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)',
    smooth: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
};
// Pre-defined transitions
export const transitions = {
    fast: `all ${durations.fast} ${easings.easeInOut}`,
    normal: `all ${durations.normal} ${easings.easeInOut}`,
    slow: `all ${durations.slow} ${easings.easeInOut}`,
    // Specific property transitions
    colors: `color ${durations.fast} ${easings.easeInOut}, background-color ${durations.fast} ${easings.easeInOut}, border-color ${durations.fast} ${easings.easeInOut}`,
    transform: `transform ${durations.normal} ${easings.easeInOut}`,
    opacity: `opacity ${durations.normal} ${easings.easeInOut}`,
    shadow: `box-shadow ${durations.normal} ${easings.easeInOut}`,
};
